import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_119: FaireProductEntity = {
  token: "legacy_prod_abbott-119",
  type: "product",
  name: "Beehive Honey Pot W Dauber-Wht",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7d41d9ce9589afa86a2cc151574c1f67b894f389c79a89f85db533f7879bef6b.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
